import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { AcademyRole, AcademyProfessor } from '../../types';

interface RoleSelectorProps {
  professor: AcademyProfessor;
  selectedRole: AcademyRole;
  roles: AcademyRole[];

  onRoleSelected: (role: AcademyRole) => void;
}

const RoleSelector = (props: RoleSelectorProps) => {
  const { professor, selectedRole, roles, onRoleSelected } = props;

  function getMenuOptions() {
    return roles.map((role, index) => (
      <MenuItem key={`${professor.id}-${role.id}`} value={role.id}>
        <FormattedMessage id={`role.${role.name.toLowerCase()}`} />
      </MenuItem>
    ));
  }

  const handleRoleSelected = useCallback(
    (event: SelectChangeEvent) => {
      const roleId = event.target.value;
      if (roleId) {
        const role = roles.find((role) => role.id === roleId);
        if (role) {
          onRoleSelected(role);
        }
      }
    },
    [onRoleSelected, roles]
  );

  return (
    <FormControl fullWidth>
      <Select onChange={handleRoleSelected} value={selectedRole.id} variant="standard">
        {getMenuOptions()}
      </Select>
    </FormControl>
  );
};

RoleSelector.propTypes = {
  selectedRoleId: PropTypes.string,
  roles: PropTypes.array.isRequired,

  onRoleSelected: PropTypes.func.isRequired,
};

RoleSelector.defaultProps = {
  selectedRoleId: undefined,
};

export default RoleSelector;
